import { render, staticRenderFns } from "./PreviewFormsNPR.vue?vue&type=template&id=4009c6ca"
import script from "./PreviewFormsNPR.vue?vue&type=script&lang=ts"
export * from "./PreviewFormsNPR.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports